import type {
  DashboardLeaderboardMetricId,
  DashboardLeaderboardSortMode,
} from '../../interfaces/dashboardLeaderboardActivity';

export const LEADERBOARD_METRIC_OPTIONS: { id: DashboardLeaderboardMetricId; label: string }[] = [
  { id: 'armScore', label: 'ArmScore' },
  { id: 'totalArmStrength', label: 'Total Arm Strength' },
  { id: 'ir', label: 'IR' },
  { id: 'er', label: 'ER' },
  { id: 'scaption', label: 'Scaption' },
  { id: 'grip', label: 'Grip' },
  { id: 'velocity', label: 'Velocity' },
  { id: 'svr', label: 'SVR' },
];

export const LEADERBOARD_SORT_OPTIONS: { id: DashboardLeaderboardSortMode; label: string }[] = [
  { id: 'topScore', label: 'Top Score' },
  { id: 'mostImproved', label: 'Most Improved' },
  { id: 'leastImproved', label: 'Least Improved' },
];

export const LEADERBOARD_POSITION_OPTIONS = [
  { value: '', label: 'All positions' },
  { value: 'Pitcher', label: 'Pitcher' },
  { value: 'Catcher', label: 'Catcher' },
  { value: 'Infield', label: 'Infield' },
  { value: 'Outfield', label: 'Outfield' },
];

export function rangeSubtitle(rangePreset: string): string {
  const map: Record<string, string> = {
    all: 'All time',
    '1W': 'Last week',
    '1M': 'Last month',
    '3M': 'Last 3 months',
    '6M': 'Last 6 months',
    '1Y': 'Last year',
    custom: 'Custom range',
  };
  return map[rangePreset] ?? 'Selected range';
}
